import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`coa`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`coa`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`coa`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`coa/` + id);
  return response;
};
